<rid-klankvoeten
  class="h-dvh"
  [assignments]="[
    {
      word: 'tijger',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
      klankvoeten: [
        { part: 'tij', type: '>' },
        { part: 'ger', type: '<' },
      ],
      rule: 'SPLIT_BEFORE_CENTRAL_CONSONANT',
    },
    {
      word: 'leeuw',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
      klankvoeten: [{ part: 'leeuw', type: '>' }],
      rule: 'SPLIT_AFTER_MULTITEKEN_KLANK',
    },
    {
      word: 'olifant',
      audio: { pronounce: 'olifant' },
      klankvoeten: [
        { part: 'o', type: '>' },
        { part: 'li', type: '>' },
        { part: 'fant', type: '>' },
      ],
      rule: 'SPLIT_BEFORE_CENTRAL_CONSONANT',
    },
  ]"
  (finished)="router.navigate(['mechanics/phonetic-comprehension'])"
/>
